import React, { useState, useEffect } from "react";
import moment from "moment";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
// mui
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
// component
import CitiesData from "./cities.json";
import Passengers from "./Passengers";
import CalendarComponent from "./CalendarComponent";
// React icons
import { HiArrowsRightLeft } from "react-icons/hi2";
// React Bootstrap
import Dropdown from "react-bootstrap/Dropdown";
// API
import {
  searchBuses,
  requestInfo,
  updateDepartureDate,
  updateDates,
} from "../../../actions/buses";
// Redux
import { connect } from "react-redux";
import language from "../../../language";
import { useDispatch, useSelector } from "react-redux";
const SearchForm = ({ buses: { buses } }) => {
  let history = useHistory();
  const dispatch = useDispatch();
  let languageSelectedEnglish =
    sessionStorage.getItem("language") === "english" ||
    !sessionStorage.getItem("language")
      ? true
      : false;

  const [formData, setFormData] = useState({
    from: "",
    to: "",
    date: moment().format("YYYY-MM-DD"),
  });
  const CityNames = useSelector((state) => state?.buses?.allCities);
  const [departureDate, setDepartureDate] = useState(
    moment().format("DD MMM YY")
  );
  const [returnDate, setReturnDate] = useState(moment().format("DD MMM YY"));
  const [infantCount, setInfantCount] = useState(0);
  const [childCount, setChildCount] = useState(0);
  const [adultCount, setAdultCount] = useState(1);
  const [totalPassenger, setTotalPassenger] = useState(0);
  const [tripType, setTripType] = useState("One Way");
  const [showDropdown, setShowDropdown] = useState(false);
  const [showPassengerDropdown, setShowPassengerDropdown] = useState(false);
  const [requestInfor, setRequestInfor] = useState({
    from: "",
    to: "",
    departureDate: moment().format("YYYY-MM-DD"),
    returnDate: moment().format("YYYY-MM-DD"),
    infantCount: infantCount,
    childCount: childCount,
    adultCount: adultCount,
    totalPassenger: 0,
    tripType: "One Way",
  });
  const [departureDayName, setDepartureDayName] = useState("");
  const [returnDayName, setReturnDayName] = useState("");

  useEffect(() => {
    if (requestInfor.departureDate) {
      const dayName = moment(requestInfor.departureDate).format("dddd");
      setDepartureDayName(dayName);
    }
  }, [requestInfor.departureDate]);

  useEffect(() => {
    if (requestInfor.returnDate) {
      const dayName = moment(requestInfor.returnDate).format("dddd");
      setReturnDayName(dayName);
    }
  }, [requestInfor.returnDate]);

  useEffect(() => {
    setRequestInfor({
      from: formData.from,
      to: formData.to,
      departureDate: departureDate,
      returnDate: returnDate,
      totalPassenger: totalPassenger,
      tripType: tripType,
      infantCount: infantCount,
      childCount: childCount,
      adultCount: adultCount,
    });
  }, [
    formData,
    departureDate,
    adultCount,
    childCount,
    infantCount,
    returnDate,
    totalPassenger,
    tripType,
  ]);

  useEffect(() => {
    setTotalPassenger(infantCount + childCount + adultCount);
  }, [infantCount, childCount, adultCount]);

  function handleChange(event, value) {
    const name = event.target.name || event.target.id;
    const newValue = value ? value.cityName : event.target.value;

    setFormData({
      ...formData,
      [name]: newValue,
    });
  }

  function handleSubmit(event) {
    if (formData.from != "" && formData.to != "" && formData.date != "") {
    }
    event.preventDefault();
  }

  const searchBusSbmit = async () => {
    if (!formData.from || !formData.to) {
      Swal.fire({
        icon: "error",
        title: "Missing Information",
        text: "Please enter both Departure and Arrival cities",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK",
        customClass: {
          title: "swal-title",
          content: "swal-text",
        },
      });
      return;
    }

    await searchBuses(formData);
    // await requestInfo(formData)
    dispatch(requestInfo(requestInfor));

    history.push(`/client/bus-listing`);
    // ?from=${requestInfor.from}&to=${requestInfor.to}&date=${requestInfor.departureDate}
  };
  const CityNames1 = [
    { cityName: "Jeddah", countryShort: "Saudi Arabia" },
    { cityName: "Makkah", countryShort: "Saudi Arabia" },
    { cityName: "Riyadh", countryShort: "Saudi Arabia" },
    { cityName: "Dubai", countryShort: "UAE" },
    { cityName: "Sharjah", countryShort: "UAE" },
    { cityName: "Madinah", countryShort: "Saudi Arabia" },
    { cityName: "Dammam", countryShort: "Saudi Arabia" },
    { cityName: "Taif", countryShort: "Saudi Arabia" },
    { cityName: "Jizan", countryShort: "Saudi Arabia" },
    { cityName: "Kuwait", countryShort: "Kuwait" },
    { cityName: "Manama", countryShort: "Bahrain" },
    { cityName: "Abu Dhabi", countryShort: "UAE" },
    { cityName: "Al Ain", countryShort: "UAE" },
    { cityName: "Ras Al Khaimah", countryShort: "UAE" },
    { cityName: "Buraydah", countryShort: "Saudi Arabia" },
    { cityName: "Al Khobar", countryShort: "Saudi Arabia" },
    { cityName: "Al Jubail", countryShort: "Saudi Arabia" },
    { cityName: "Jazan", countryShort: "Saudi Arabia" },
  ];

  const fromOptions = CityNames.filter((city) => city.cityName !== formData.to);

  const toOptions = CityNames.filter((city) => city.cityName !== formData.from);

  const handleCloseDropdown = () => {
    setShowDropdown(false);
    if (requestInfor.tripType === "One Way") {
      dispatch(updateDepartureDate(departureDate));
    } else {
      dispatch(updateDates(departureDate, returnDate));
    }
  };

  return (
    <>
      <Grid
        item
        xl={12}
        lg={12}
        md={12}
        flexDirection="column"
        style={{ marginTop: "10px" }}
      >
        <div className="form" onSubmit={handleSubmit}>
          <div className="homeFromToOuter">
            <Grid
              className="form-each-box relative homeSelect"
              paddingLeft="0"
              paddingRight="0"
            >
              <Autocomplete
                className="locationSelect"
                disablePortal
                id="from"
                options={fromOptions}
                sx={{ width: "100%" }}
                value={
                  CityNames.find((city) => city.cityName === formData.from) ||
                  null
                }
                onChange={(event, newValue) => {
                  handleChange({
                    target: {
                      name: "from",
                      value: newValue ? newValue.cityName : "",
                    }, // ✅ only city in state
                  });
                }}
                getOptionLabel={(option) => option.cityName} // ✅ input field shows only city
                renderOption={(props, option) => (
                  <li {...props}>
                    <span className="cityfontSize"> {option.cityName}</span>,{" "}
                    {option.countryShort}{" "}
                    {/* ✅ dropdown shows City, countryShort */}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    cityName={languageSelectedEnglish ? "From" : language.from}
                    name="from"
                    required
                  />
                )}
              />
            </Grid>
            <Grid item xs={1} alignSelf="center" className="arrowBetFromTo">
              <HiArrowsRightLeft className="arrowdirection" />
            </Grid>
            <Grid
              className="form-each-box homeSelect"
              paddingLeft="0"
              paddingRight="0"
            >
              <Autocomplete
                className="locationSelect"
                disablePortal
                id="to"
                options={toOptions}
                sx={{ width: "100%" }}
                value={
                  CityNames.find((city) => city.cityName === formData.to) ||
                  null
                } // ✅ keep correct ref
                onChange={(event, newValue) => {
                  handleChange({
                    target: {
                      name: "to",
                      value: newValue ? newValue.cityName : "",
                    }, // ✅ store only city
                  });
                }}
                getOptionLabel={(option) => option.cityName} // ✅ input field shows only city
                renderOption={(props, option) => (
                  <li {...props}>
                    <span className="cityfontSize"> {option.cityName}</span>,{" "}
                    {option.countryShort}{" "}
                    {/* ✅ dropdown shows City, countryShort */}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    cityName={languageSelectedEnglish ? "To" : language.to}
                    name="to"
                    required
                  />
                )}
              />
            </Grid>
          </div>
          <Grid
            item
            xs={12}
            className="form-each-box"
            width="100%"
            display="block"
            paddingLeft="0"
            paddingRight="0"
            style={{ marginTop: "15px" }}
          >
            {/* <img src={building} alt="" className="form-logo" /> */}
            <Dropdown
              show={showDropdown}
              onToggle={(isOpen) => setShowDropdown(isOpen)}
              autoClose={false}
            >
              <Dropdown.Toggle
                variant="success"
                id="dropdown-passenger"
                onClick={() => setShowDropdown(!showDropdown)}
              >
                <Grid
                  container
                  xs={12}
                  justifyContent="space-between"
                  className="timing-wrapper"
                >
                  <Grid
                    item
                    xs={tripType === "One Way" ? 12 : 4}
                    align="center"
                  >
                    <p className="tour-title">
                      {languageSelectedEnglish
                        ? "Departure Date"
                        : language.departureDate}
                    </p>
                    <p className="tour-date">{departureDate}</p>
                    <p className="tour-day">{departureDayName}</p>
                  </Grid>
                  {tripType === "Round Trip" && (
                    <Grid item alignSelf="center">
                      <div className="horizontal-rule" />
                    </Grid>
                  )}
                  {tripType === "Round Trip" && (
                    <Grid item xs={4} align="center">
                      <p className="tour-title">
                        {languageSelectedEnglish
                          ? " Return Date"
                          : language.returnDate}
                      </p>
                      <p className="tour-date">{returnDate}</p>
                      <p className="tour-day">{returnDayName}</p>
                    </Grid>
                  )}
                </Grid>
              </Dropdown.Toggle>
              <Dropdown.Menu className="dateSelectDropdown">
                <CalendarComponent
                  departureDate={departureDate}
                  setDepartureDate={setDepartureDate}
                  returnDate={returnDate}
                  setReturnDate={setReturnDate}
                  tripType={tripType}
                  setTripType={setTripType}
                  isPackage={false}
                  onClose={handleCloseDropdown}
                  noOption={true}
                  setRequestInfor={setRequestInfor}
                  requestInfor={requestInfor}
                />
              </Dropdown.Menu>
            </Dropdown>
            <Grid item xs={12} className="passenger-wrap" marginTop="10px">
              <p className="form-heading">
                {languageSelectedEnglish ? "Passengers" : language.passengers}
              </p>
              <Dropdown
                show={showPassengerDropdown}
                autoClose={false}
                onToggle={(isOpen) => setShowPassengerDropdown(isOpen)}
              >
                <Dropdown.Toggle
                  variant="success"
                  id="dropdown-passenger"
                  onClick={() =>
                    setShowPassengerDropdown(!showPassengerDropdown)
                  }
                >
                  <input
                    name="input"
                    type="text"
                    value={
                      infantCount && childCount && adultCount == 0
                        ? ""
                        : `${infantCount} ${
                            languageSelectedEnglish
                              ? "Infants"
                              : language.infants
                          } , ${childCount} ${
                            languageSelectedEnglish
                              ? "Children"
                              : language.children
                          }, ${adultCount} ${
                            languageSelectedEnglish ? "Adults" : language.adults
                          }`
                    }
                    placeholder={
                      languageSelectedEnglish
                        ? languageSelectedEnglish
                          ? "Not Selected"
                          : language.notSelected
                        : language.notSelected
                    }
                    readOnly
                    // value={formData.date}
                    // onChange={handleChange}
                    // min={moment().format("YYYY-MM-DD")}

                    className="form-input-text"
                  ></input>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Passengers
                    infantCount={infantCount}
                    setInfantCount={setInfantCount}
                    childCount={childCount}
                    setChildCount={setChildCount}
                    adultCount={adultCount}
                    setAdultCount={setAdultCount}
                    onClose={() => setShowPassengerDropdown(false)}
                  />
                </Dropdown.Menu>
              </Dropdown>
            </Grid>
          </Grid>
          <Grid item xs={12} align="center" className="homeSearch">
            <button
              type="submit"
              className="form-submit-button"
              onClick={searchBusSbmit}
            >
              {languageSelectedEnglish
                ? " Search Bus Trips"
                : language.searchBusTrips}
            </button>
          </Grid>
        </div>
      </Grid>
    </>
  );
};

SearchForm.propTypes = {
  // addLike: propTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  buses: state.buses,
});

export default connect(mapStateToProps, null)(SearchForm);
